import type { Trace } from '@/features/traceability/type/Tool';

type CountEntry = [string, number];

type TraceGroupings = {
  machineUsage: CountEntry[];
  operatorUsage: CountEntry[];
  changeReasons: CountEntry[];
};

function groupAndSort(values: string[]): CountEntry[] {
  const counts = new Map<string, number>();
  for (const value of values) {
    counts.set(value, (counts.get(value) ?? 0) + 1);
  }
  return Array.from(counts.entries()).sort((a, b) => b[1] - a[1]);
}

export function computeTraceGroupings(traces: Trace[]): TraceGroupings {
  const machineNames = traces
    .map((trace) => trace.machine?.name)
    .filter((name): name is string => name !== null && name !== undefined);

  const operatorNames = traces
    .map((trace) => trace.operator)
    .filter((op): op is string => op !== null && op !== undefined);

  const reasons = traces.flatMap((trace) => trace.toolState?.changeReason ?? []);

  return {
    machineUsage: groupAndSort(machineNames),
    operatorUsage: groupAndSort(operatorNames),
    changeReasons: groupAndSort(reasons),
  };
}
